import { render, staticRenderFns } from "./AreaEmbargadaCe.vue?vue&type=template&id=7fac2846&lang=pug"
import script from "./AreaEmbargadaCe.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaCe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports